import { withSvgIconSimple } from './withSvgIconSimple';

export const Freeze = withSvgIconSimple(
  <>
    <path
      d="M12 3V21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M3 12L21 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M7 4L12 9L17 4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M4 17L9 12L4 7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M20 7L15 12L20 17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M17 20L12 15L7 20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
